import { toNumber } from 'lodash';

export const parseNumbersFromString = (s: string) => toNumber(s.replace(/[^\d.-]/g, ''));

export const matchTextByWords = (text: string, wordsToMatch: string[]) => {
  const lower = text.toLowerCase();
  return wordsToMatch.every((word) => lower.includes(word.toLowerCase()));
};
